import { useEffect, useState } from "react";

export const useCreateOptions = (status) => {
  const [disabled, setDisabled] = useState(false);
  useEffect(() => {
    switch (status) {
      case "pendingManu":
      case "inProgress":
      case "finished":
        setDisabled(false);
        break;
      default:
        setDisabled(true);
    }
  }, [status]);
  return disabled;
};
